import {
  AUTORUN_START_TRACK,
  COMPLETE_TRACK,
  COMPLETE_BRANCH,
  FINALIZE_TRACK,
  CONFIRM_INTERRUPT,
  DISMISS_CARD,
  INTERRUPT_TRACK,
  NAVIGATE_TO_URL,
  NEXT_STEP,
  SET_DATA,
  SHOW_ONBOARDING_MODAL,
  START_TRACK,
  // LOAD_PROGRESS,
  // SAVE_PROGRESS,
} from './types'

export const actionStartTrack = (trackId) => ({
  type: START_TRACK,
  payload: { trackId },
})

export const actionCompleteTrack = () => ({
  type: COMPLETE_TRACK,
})

export const actionCompleteBranch = (branchId) => ({
  type: COMPLETE_BRANCH,
  payload: { branchId },
})

export const actionFinalizeTrack = (branchId = null) => ({
  type: FINALIZE_TRACK,
  payload: { branchId },
})

export const actionNextStep = () => ({
  type: NEXT_STEP,
})

export const actionNavigateToUrl = (url, route, routeParams, params, cardContext = {}) => ({
  type: NAVIGATE_TO_URL,
  payload: { url, route, routeParams, params, ...cardContext },
})

export const actionSetData = (data) => ({
  type: SET_DATA,
  payload: data,
})

export const actionDismissCard = () => ({
  type: DISMISS_CARD,
})

export const actionInterruptTrack = () => ({
  type: INTERRUPT_TRACK,
})

export const actionShowOnboardingModal = (card) => ({
  type: SHOW_ONBOARDING_MODAL,
  payload: { card },
})

export const actionConfirmInterrupt = () => ({
  type: CONFIRM_INTERRUPT,
})

// TODO(backend): enable when onboarding progress API is ready
// export const actionLoadProgress = () => ({
//   type: LOAD_PROGRESS,
// })
//
// export const actionSaveProgress = (progress) => ({
//   type: SAVE_PROGRESS,
//   payload: progress,
// })

export const actionAutorunStartTrack = (trackId) => ({
  type: AUTORUN_START_TRACK,
  payload: { trackId },
})

/**
 * Maps a card button config to a Redux action.
 * Shared by OnboardingManager (tooltip) and saga (modal).
 */
export const resolveButtonAction = (button, cardContext = {}) => {
  switch (button.action) {
    case 'next':
      return actionNextStep()
    case 'navigate':
      return (button.url || button.route)
        ? actionNavigateToUrl(button.url, button.route, button.routeParams, button.params, cardContext)
        : null
    case 'close':
      return actionDismissCard()
    case 'complete':
      return actionCompleteTrack()
    case 'completeBranch':
      return button.branchId ? actionCompleteBranch(button.branchId) : null
    case 'finalize':
      return actionFinalizeTrack(button.branchId || null)
    case 'interrupt':
      return actionInterruptTrack()
    case 'confirm-interrupt':
      return actionConfirmInterrupt()
    default:
      return actionNextStep()
  }
}
